<section fxLayout="column" class="flex-between-start sidemenu">
  <article fxLayout="column" style="align-items: stretch; justify-content: center;">
    <cube-sidemenu-item *ngFor="let entry of menu" [entry]="entry" [iconOnly]="iconOnly" (clicked)="clicked.emit($event)"></cube-sidemenu-item>
  </article>
  <article fxLayout="column" class="flex-end-center" [style.margin]="'50px 0px 0px'">
    <a href="https://www.rina.org" target="_blank" alt="RINA.org" title="RINA S.P.A.">
      <img width="{{ iconOnly ? 50 : 75 }}" src="./assets/rina/RINA-light.png" />
    </a>
    <p class="version">{{ version.version }}</p>
  </article>
</section>